import { api } from '@services';

import CustomField, {
  ICustomField,
  ICustomFieldApiModel,
} from '@models/CustomField.model';
import qs from 'query-string';

interface IIndexStudioCustomField {
  id: string;
  sort?: string;
  direction?: 'ASC' | 'DESC';
}
const getStudioCustomField = async ({
  id,
  direction,
  sort,
}: IIndexStudioCustomField): Promise<ICustomField[]> => {
  const queryObject = {
    sort,
    direction,
  };
  const queryString = qs.stringify(queryObject);
  const { data: customFields } = await api.get<ICustomFieldApiModel[]>(
    `/studios/${id}/customField?${queryString}`,
  );

  return CustomField.arrayFromApiModel(customFields);
};

export { getStudioCustomField };
